module.exports = __webpack_public_path__ + "img/4bhk-f.d8ca7123.jpg";